/**
 * Newsletter Modal Module
 * Handles the newsletter signup modal functionality
 */

export function initNewsletterModal() {
  const modal = document.getElementById('newsletter-modal');
  const openButton = document.getElementById('signup-button');
  const closeButton = modal ? modal.querySelector('.newsletter-modal-close') : null;
  const overlay = modal ? modal.querySelector('.newsletter-modal-overlay') : null;

  if (!modal || !openButton) {
    return;
  }

  // Open modal
  function openModal(e) {
    e.preventDefault();
    modal.style.display = 'flex';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  // Close modal
  function closeModal() {
    modal.classList.remove('active');
    setTimeout(() => {
      modal.style.display = 'none';
      document.body.style.overflow = ''; // Restore scrolling
    }, 300); // Wait for animation to complete
  }

  // Event listeners
  openButton.addEventListener('click', openModal);

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

  console.log('[SOJ] Newsletter modal initialized');
}
